module.exports = __webpack_public_path__ + "wdl_slide_desktop.webp";